<template>
</template>

<script>
import DingtalkService from '@/api/dingtalk/DingtalkService.js'
import Vue from "vue";

export default {
  data() {
    return {

    }
  },
  mounted() {
    this.dingtalkLogin()
  },
  methods: {
    dingtalkLogin() {
		Vue.cookie.delete('token')
		
		dd.ready(() => {
			// dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
			let corpId = this.getQueryVariable('corpId')
			dd.runtime.permission.requestAuthCode({
			  corpId: corpId,
			  onSuccess: (result) => {
				new DingtalkService().dingtalkLogin(result.code, corpId).then(({data}) => {
				  if(data.code === 200) {
					Vue.cookie.set('token', data.token);
					this.$router.push({
					  path: '/invoice'
					})
				  } else {
					this.$toast.fail(data.message)
				  }
				})
			  },
			  onFail: (err) => {
				this.$message.error('err:' + JSON.stringify(err));
			  }
			});
		});
    },
    getQueryVariable(variable) {
      var query = window.location.href.split("?")[1]
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    }
  }
}
</script>
